import React from "react";
import { View } from "@/styles/reactnative";
import MarketTrendHeader from "../MarketTrendHeader";
import CryptoMarkets from "./CryptoMarkets";
import CryptoTrading from "./CryptoTrading";

const CryptoCurrencyTrend = () => {
  return (
    <View style={{ alignItems: "flex-start" }}>
      <MarketTrendHeader title={"cryptocurrencyMarketTrends"} />
      <CryptoMarkets />
      <CryptoTrading />
    </View>
  );
};

export default React.memo(CryptoCurrencyTrend);
